/* eslint-disable @typescript-eslint/no-explicit-any */
import {Vue, Component} from "vue-property-decorator";
import {getCustomerInfo} from "@/api/common";



@Component({})
export default class ApplyOfStudent extends Vue {
    tableLoading = false
    tableData = []
    customerName = ''
    limit = 20
    page = 1
    total = 0
    dialogVisible = false
    fileList = []
    studentOutputAttachment = ''
    created() {
        // this.getCustomerInfo()
    }


    async getCustomerInfo() {
        if (this.customerName) {
            const params = {
                customerName: this.customerName,
                limit: this.limit,
                page: this.page
            }

            const result: any = await getCustomerInfo(params)
            this.total = result.allNum
            this.tableData = result.financeOrderList
        }
    }

    handleChangePageSize(limit) {
        this.limit = limit
        this.getCustomerInfo();
    }

    handlechangePage(page) {
        this.page = page
        this.getCustomerInfo();
    }

    download(data) {
        this.fileList = data.studentOutputAttachmentList
        this.dialogVisible = true
    }

    doDownload(path, name) {
        /*   根据线上存储地址下载图片*/
        const xhr = new XMLHttpRequest()
        xhr.open('GET', path, true)
        xhr.responseType = 'blob'
        xhr.onload = function () {
            if (this.status === 200) {
                const blob = this.response
                const a = document.createElement('a')
                a.href = window.URL.createObjectURL(blob)
                a.download = name
                a.click()
                URL.revokeObjectURL(a.href)
            }
        }
        xhr.send()
    }

    doCancel() {
        this.dialogVisible = false
        this.fileList = []
        this.studentOutputAttachment = ''
    }
}
